/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import React, { useState, createContext, useContext, useEffect } from 'react';

const NavigationContext = createContext({});
const useNavigation = () => useContext(NavigationContext);

function NavigationProvider(props) {
  const [navigationData, setNavigationData] = useState({});

  return (
    <NavigationContext.Provider
      value={{ navigationData, setNavigationData }}
      {...props}
    />
  );
}

function withNavigationWatcher(Component) {
  return function(props) {
    const { path } = props.match;
    const { setNavigationData } = useNavigation();

    useEffect(() => {
      setNavigationData({ currentPath: path });
    }, [path, setNavigationData]);

    return React.createElement(Component, props);
  };
}

withNavigationWatcher.displayName = withNavigationWatcher;

export { NavigationProvider, useNavigation, withNavigationWatcher };
